import React from 'react';
import { FaPassport, FaUserEdit, FaDollarSign, FaCheck } from 'react-icons/fa';
import Button from './Button';
import FadeInSection from './FadeInSection';
import CardRibbon from './CardRibbon';
import PriceWithCurrency from './PriceWithCurrency';
import { usePageContext } from '../contexts/page-context';
import siteMetadata from '../siteMetadata';
import LocalizedLink from './LocalizedLink';

const getIcon = ({ index, size, className }) => {
  const icons = [
    <FaPassport className={className} size={size} />,
    <FaDollarSign className={className} size={size} />,
    <FaUserEdit className={className} size={size} />,
  ];

  return icons[index];
};

const ServicesHome = ({ headline, services, cta, className }) => {
  const {
    pageContext: { lang },
  } = usePageContext();

  return (
    <div className={className}>
      <h2 className="text-center">{headline}</h2>
      <div className="flex flex-col lg:flex-row lg:-ml-8">
        {services.map((service, i) => {
          return (
            <FadeInSection className={`flex flex-1 lg:delay-${i * 300}`}>
              <LocalizedLink
                className="lg:ml-8 mb-8 w-full relative shadow-lg rounded"
                to={service.cta_link}
                key={service.headline}
              >
                <CardRibbon className="capitalize">
                  <span className="mr-1">{lang === siteMetadata.defaultLang ? 'from' : 'desde'}</span>
                  <PriceWithCurrency prices={service.prices} className="text-2xl tracking-tight" />
                </CardRibbon>
                <div className="flex flex-col h-full rounded px-4 py-8 bg-white">
                  <div className="flex justify-center mb-4">
                    {getIcon({ index: i, size: 48, className: 'text-light-500' })}
                  </div>

                  <div className="mb-8 text-2xl text-center font-bold">{service.headline}</div>
                  <ul className="pl-8 justify-start mb-12 flex-1">
                    {service.highlights &&
                      service.highlights.map(highlight => {
                        return (
                          <li key={highlight.text} className="text font-black font-serifdisplay flex">
                            <FaCheck className="text-light-500 relative top-1 flex-none" />
                            <span className="ml-2">{highlight.text}</span>
                          </li>
                        );
                      })}
                  </ul>
                  {service.cta_link && (
                    <div className="flex justify-center text-center">
                      <div className="py-6 bg-light-100 text-light-700 text-lg font-bold rounded uppercase no-underline w-full">
                        {service.cta_label}
                      </div>
                    </div>
                  )}
                </div>
              </LocalizedLink>
            </FadeInSection>
          );
        })}
      </div>
      <div className="flex justify-center text-center ">
        {cta.link && <Button to={cta.link} label={cta.label} className="w-full lg:w-1/3" />}
      </div>
    </div>
  );
};

export default ServicesHome;
